import { Enums } from "@/enums";
import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { FinanceAccountResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const financeAccount = {
    record(data: typeof Requests.FinanceAccount.Record.Input) {
        return post<typeof data, FinanceAccountResponseTypes.Record>(
            `/finance-account/record`,
            data,
        );
    },
    create(data: typeof Requests.FinanceAccount.Create.Input) {
        return post<typeof data>(`/finance-account/create`, data);
    },
    obtain(id: string) {
        return get<FinanceAccountResponseTypes.Obtain>(`/finance-account/obtain/${id}`);
    },
    enable(id: string) {
        return postEmpty(`/finance-account/enable/${id}`);
    },
    disable(id: string) {
        return postEmpty(`/finance-account/disable/${id}`);
    },
    formHooks: {
        selectFn(method: Enums.PaymentMethodEnum.Values | undefined) {
            return (async (param?: SelectParam) => {
                if (method === undefined) return [];
                const req = get<FinanceAccountResponseTypes.Select>(
                    `/finance-account/select/${method}` + buildSelectParam(param),
                );

                return (await req.execute()) ?? [];
            }) satisfies SelectHook;
        },
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.FinanceAccount.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/finance-account/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
